export const GET_FOOD = 'GET_FOOD';
export const ADD_FOOD = 'ADD_FOOD';
export const DELETE_FOOD = 'DELETE_FOOD';
export const UPDATE_FOOD = 'UPDATE_FOOD';
export const FOOD_ERROR = 'FOOD_ERROR';
